
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Optimiser le budget de vos campagnes Facebook Ads efficacement",
    description:
      "Découvrez comment optimiser le budget de vos campagnes Facebook Ads avec ALEO. Gérez vos dépenses, améliorez vos enchères et maximisez votre ROI simplement.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
